export function getHeaderLang(lang: General.SystemLanguage) {
  switch (lang) {
    case 'en-US':
      return 'en_US';
    case 'zh-CN':
      return 'zh_CN';
    case 'tl':
      return 'ph';
    default:
      return lang;
  }
}
